:host {
  width: 100%;
}

.notification, .notification.info {
  display: flex;
  border-style: solid;
  border-color: var(--color-support-info);
  border-width: 1px;
  border-left-width: 3px;
  color: var(--color-text-primary);
  min-height: var(--spacing-09);
}

.notification.success {
  border-color: var(--color-support-success);
}

.notification.warn {
  border-color: var(--color-support-warning);
}

.notification.error {
  border-color: var(--color-support-error);
}

svg {
  width: 24px;
  height: 24px;
}

.details.info > svg {
  fill: var(--color-support-info);
}

.details.success > svg {
  fill: var(--color-support-success);
}

.details.warn > svg {
  fill: var(--color-support-warning);
}

.details.error > svg {
  fill: var(--color-support-error);
}

.details {
  padding-top: var(--spacing-04);
  margin-left: var(--spacing-05);
  margin-right: var(--spacing-05);
}

.text-wrapper {
  padding-top: var(--spacing-05);
  padding-bottom: var(--spacing-04);
}
